import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import PoliciesView from "../views/PoliciesView.vue";
import ThankView from "../views/ThankView.vue";
import error from "../views/error.vue";
import ConfirmationPage from "../views/confirmationPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/pages/thank",
    name: "thank",
    component: ThankView,
  },
  {
    path: "/pages/policy/:id?",
    name: "policy",
    component: PoliciesView,
  },
  {
    path: "/pages/404",
    name: "error404",
    component: error,
    meta: {
      hideNavbar: true,
      hideFooter: true
    }
  },
  {
    path: "/pages/confirmation",
    name: "confirmation",
    component: ConfirmationPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
